// package: concierge_billing
// file: billing-concierge.proto

var billing_concierge_pb = require("./billing-concierge_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var google_protobuf_wrappers_pb = require("google-protobuf/google/protobuf/wrappers_pb");
var common_pb = require("./common_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var BillingConciergeApiService = (function () {
  function BillingConciergeApiService() {}
  BillingConciergeApiService.serviceName = "concierge_billing.BillingConciergeApiService";
  return BillingConciergeApiService;
}());

BillingConciergeApiService.getBillingPriceRanges = {
  methodName: "getBillingPriceRanges",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: billing_concierge_pb.BillingConciergePriceRangeResponse
};

BillingConciergeApiService.getBillingDetails = {
  methodName: "getBillingDetails",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: billing_concierge_pb.BillingConciergeResponse
};

BillingConciergeApiService.cancelBillingSubscription = {
  methodName: "cancelBillingSubscription",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_concierge_pb.BillingConciergeCancellationRequest,
  responseType: google_protobuf_empty_pb.Empty
};

BillingConciergeApiService.resumeBillingSubscription = {
  methodName: "resumeBillingSubscription",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: google_protobuf_empty_pb.Empty
};

BillingConciergeApiService.updateCreditCardInfo = {
  methodName: "updateCreditCardInfo",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_concierge_pb.UpdateCreditCardRequest,
  responseType: billing_concierge_pb.CreditCardInfo
};

BillingConciergeApiService.getInvoices = {
  methodName: "getInvoices",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: billing_concierge_pb.InvoiceRequest,
  responseType: billing_concierge_pb.InvoiceShortResponse
};

BillingConciergeApiService.getInvoiceDetails = {
  methodName: "getInvoiceDetails",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: billing_concierge_pb.InvoiceDetailsResponse
};

BillingConciergeApiService.getBraintreeToken = {
  methodName: "getBraintreeToken",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: google_protobuf_wrappers_pb.StringValue
};

BillingConciergeApiService.makePayment = {
  methodName: "makePayment",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_concierge_pb.PaymentRequest,
  responseType: billing_concierge_pb.PaymentResponse
};

BillingConciergeApiService.makeInvoicePayment = {
  methodName: "makeInvoicePayment",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_concierge_pb.PaymentInvoiceRequest,
  responseType: billing_concierge_pb.PaymentResponse
};

BillingConciergeApiService.getBillingAddress = {
  methodName: "getBillingAddress",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: billing_concierge_pb.BillingAddress
};

BillingConciergeApiService.updateBillingAddress = {
  methodName: "updateBillingAddress",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_concierge_pb.BillingAddress,
  responseType: billing_concierge_pb.BillingAddress
};

BillingConciergeApiService.calcDiscount = {
  methodName: "calcDiscount",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_concierge_pb.BillingConciergeDiscountRequest,
  responseType: google_protobuf_wrappers_pb.DoubleValue
};

BillingConciergeApiService.generateInvoicePdf = {
  methodName: "generateInvoicePdf",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: common_pb.FileResponse
};

BillingConciergeApiService.generateInvoicesPdfArchive = {
  methodName: "generateInvoicesPdfArchive",
  service: BillingConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdContainer,
  responseType: common_pb.FileResponse
};

exports.BillingConciergeApiService = BillingConciergeApiService;

function BillingConciergeApiServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

BillingConciergeApiServiceClient.prototype.getBillingPriceRanges = function getBillingPriceRanges(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.getBillingPriceRanges, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.getBillingDetails = function getBillingDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.getBillingDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.cancelBillingSubscription = function cancelBillingSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.cancelBillingSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.resumeBillingSubscription = function resumeBillingSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.resumeBillingSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.updateCreditCardInfo = function updateCreditCardInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.updateCreditCardInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.getInvoices = function getInvoices(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(BillingConciergeApiService.getInvoices, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.getInvoiceDetails = function getInvoiceDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.getInvoiceDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.getBraintreeToken = function getBraintreeToken(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.getBraintreeToken, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.makePayment = function makePayment(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.makePayment, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.makeInvoicePayment = function makeInvoicePayment(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.makeInvoicePayment, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.getBillingAddress = function getBillingAddress(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.getBillingAddress, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.updateBillingAddress = function updateBillingAddress(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.updateBillingAddress, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.calcDiscount = function calcDiscount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.calcDiscount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.generateInvoicePdf = function generateInvoicePdf(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.generateInvoicePdf, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingConciergeApiServiceClient.prototype.generateInvoicesPdfArchive = function generateInvoicesPdfArchive(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingConciergeApiService.generateInvoicesPdfArchive, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.BillingConciergeApiServiceClient = BillingConciergeApiServiceClient;

